/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Classe énergétique du bien.
 */
export const energyPropertySchema = z.enum(["A", "B", "C", "D", "E", "F", "G"]).describe("Classe énergétique du bien.")